import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ColorConstants from 'constants/ColorConstants';

const CloseModalButton = ({ onHide }) => {
  return (
    <React.Fragment>
      <div style={{float:"right"}}>
        <CloseIcon data-testid="CloseIcon" onClick={onHide} style={{color:ColorConstants.LIGHT_GREY, cursor:"pointer", fontSize: 16}}/>
      </div>
      <div style={{clear:"both"}}/>
    </React.Fragment>
  );
}

export default CloseModalButton;